import { HTMLAttributes, useState } from 'react';

/*
 * Takes regular HTML input attributes as input and attaches listeners to observe whether the inputs value and focus.
 * Returns an 'isActive' flag and the enhanced 'inputProps'
 */
export const useInputHasValue = <AttributeTypes extends HTMLAttributes<any>>(
  props: AttributeTypes,
  valueProp: keyof AttributeTypes,
) => {
  const [hasFocus, setHasFocus] = useState(false);
  const [hasValue, setHasValue] = useState(!!props[valueProp]);
  const isActive = hasFocus || hasValue;

  const inputProps: AttributeTypes = {
    ...props,
    onFocus: (e) => {
      props.onFocus?.(e);
      setHasFocus(true);
    },
    onBlur: (e) => {
      props.onBlur?.(e);
      setHasFocus(false);
    },
    onInput: (e) => {
      props.onInput?.(e);
      setHasValue(!!e.currentTarget[valueProp]);
    },
  };

  return {
    isActive,
    inputProps,
  };
};
